module.exports = __webpack_public_path__ + "static/media/dark-logo.419e5215.svg";